<template>
    <div class="main">
        <fade-transition :duration="{enter: 500, leave: 100}" appear>
            <editor-carousel v-show="hoverIdx !== null"
                             :slides="slides"
                             :slideIdx="hoverIdx"
            ></editor-carousel>
        </fade-transition>

        <fade-transition :duration="{enter: 1000, leave: 10}" mode="out-in" appear>
            <div class="editorsSection">
                <div class="containerWrapper">
                    <div class="container">
                        <div class="container__inner">
                            <div class="headlineWrapper">
                                <h1 class="headline">
                                    {{title}}
                                </h1>
                            </div>

                            <div ref="editorsListContainer" :class="editorsListContainerClasses">
                                <ul ref="editorsListWrapper" :class="editorsClasses">
                                    <li v-for="(editor, index) in editorsActive"
                                        :key="editor.name"
                                        class="editorsList"
                                    >
                                        <router-link :to="{ path: editor.reel }"
                                                     :class="editorLinkClasses(editor)"
                                                     @mouseover.native="onHover(editor, index)"
                                                     @mouseleave.native="onLeave(editor)"
                                        >{{ editor.name}}
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!--
                    currently unused
                    <div class="editorsImgBgs">
                        <fade-transition>
                            <img v-if="roll.show"
                                 :src="roll.url"
                                 :key="roll.url"
                                 class="visible"
                                 alt="">
                        </fade-transition>
                    </div>-->
                </div>
            </div>
        </fade-transition>
    </div>
</template>

<script>
    import _throttle from 'lodash/throttle'
    import {mapState, mapActions, mapGetters} from 'vuex'
    import {menusMixin} from "../mixins/menus";
    import {preloadImg} from "../utils/shared";
    import {menusNames as mn} from "../constants/menus";

    export default {
        mixins: [menusMixin],
        data() {
            return {
                hover: false,
                hoverIdx: null,
                rolls: false,
                show: true,
                roll: {
                    show: false,
                    index: null,
                    url: null,
                },
                rollTm: null,
                editorsListWrapper: null,
                editorsListContainer: null,
                editorsListWrapperH: 0,
                editorsListContainerH: 0,
            }
        },
        computed: {
            ...mapGetters('editors', {
                slides: 'slides',
                hoveredEditor: 'hoveredEditor',
                editorsActive: 'active',
            }),
            ...mapGetters('ui', {
                'isMobile': 'isMobile',
                'canAutoplay': 'canAutoplay',
            }),
            ...mapGetters('home', {
                'posterFallback': 'posterFallback',
            }),
            editorsClasses() {
                return [
                    'editorsListWrapper',
                    {'editorsListWrapper-hovered': this.hover},
                ]
            },
            editorLinkClasses() {
                return (editor) => {
                    return [
                        'editorsList__link',
                        {'editorsList__link-hovered': editor === this.hover},
                    ]
                }
            },
            editorsListContainerClasses() {
                return [
                    'editorsListContainer',
                    {'editorsListContainer-small': this.editorsListWrapperH > this.editorsListContainerH},
                ]
            },
            ...mapState({
                editors: state => state.editors.list,
            }),
            title() {
                return this.$_getMenuName(mn.EDITORS)
            }
        },
        beforeRouteLeave(to, from, next) {
            //console.log('beforeRouteLeave')
            this.onLeave()
            next()
        },
        created() {
            //debugger
            this.$store.dispatch('editors/initSlides')
            this.trottledOnResize = _throttle(this.onResize, 30);

            this.$store.dispatch('player/setBack', '/');

            window.addEventListener('resize', this.trottledOnResize)
            window.addEventListener('scroll', this.trottledOnResize)
        },
        mounted() {
            this.containerInner = document.querySelector('.editorsSection .container__inner')
            this.editorsListWrapper = $(this.$refs.editorsListWrapper);
            this.editorsListContainer = $(this.$refs.editorsListContainer);

            this.trottledOnResize = _throttle(this.onResize, 30);
            /*window.addEventListener('resize', this.trottledOnResize)
            window.addEventListener('scroll', this.trottledOnResize)*/
            this.onResize()

            //this.preloadBackgrounds()
            this.setSeo(this.$_getMenuSeo(mn.EDITORS))
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.trottledOnResize)
            window.removeEventListener('scroll', this.trottledOnResize)
        },
        methods: {
            ...mapActions('ui', {
                'setSeo': 'setSeo',
            }),
            /*
            async preloadBackgrounds() {
                let self = this
                //console.log('editors: mounted')
                if (this.canAutoplay) {
                    this.backgrounds.map((slide) => {
                        this.$store.commit('editors/setLoadedBackground', slide)
                    })
                } else {
                    let all = this.backgrounds.map((slide) => {
                        let poster = self.posterFallback(slide)
                        let promise = Promise.resolve()

                        if (!slide._loaded && poster) {
                            promise = preloadImg(poster)
                                .then(() => {
                                    this.$store.commit('editors/setLoadedBackground', slide)
                                }).catch(() => {})
                        }

                        return promise
                    })

                    await Promise.all(all)
                        .then(() => {
                            console.log('backgrounds preloaded')
                        })
                }
            },
            */
            onHover(editor, index) {
                if (this.isMobile) {
                    return
                }

                this.hover = editor
                this.hoverIdx = index

                this.rollVideos(editor)
                //this.rollImages(editor)
            },
            onLeave() {
                if (this.isMobile) {
                    return
                }
                //return
                clearTimeout(this.rollTm)
                this.hover = false
                this.hoverIdx = null
                this.rolls = false
                this.roll = {
                    show: false,
                    index: null,
                    url: null,
                }
                this.setHoveredEditor(null)
            },
            /* currently commented as unused
            rollImages(editor) {
                this.rolls = editor.rolls.list || []

                if (!this.rolls.length) {
                    return
                }

                let all = this.rolls.map((roll) => {
                    return preloadImg(roll.url).catch(() => {})
                })

                let loop = () => {
                    this.toggleRoll()
                    clearTimeout(this.rollTm)
                    this.rollTm = setTimeout(loop, 2000)
                }

                Promise.all(all)
                    .then(() => {
                        this.roll.index = 0
                        this.roll.show = true
                        this.rollTm = setTimeout(loop, 10)
                    })
            },
            toggleRoll() {
                //console.log('toggleRoll')
                if (!this.roll.show) {
                    return
                }

                if (this.roll.index >= this.rolls.length) {
                    this.roll.index = 0
                }

                this.roll.show = false
                this.roll.url = this.rolls[this.roll.index++].url
                this.roll.show = true
            },
            */
            rollVideos(editor) {
                this.setHoveredEditor(editor)
            },
            setHoveredEditor(editor) {
                this.$store.dispatch('editors/setHoveredEditor', editor)
            },
            onResize() {
                this.editorsListWrapperH = this.editorsListWrapper.height()
                this.editorsListContainerH = this.editorsListContainer.height()

                if (this.containerInner) {
                    this.containerInner.style.height = window.innerHeight + 'px'
                }
            },
        },
    }
</script>
